import api from './api';

export interface RefundNotification {
  readonly id: string;
  readonly orderId: string | null;
  readonly amount: number;
  readonly currency: string;
  readonly reason: string | null;
  readonly createdAt: string;
}

export interface RefundNotificationsResponse {
  readonly notifications: ReadonlyArray<RefundNotification>;
}

/**
 * Get pending refund notifications for the current user
 */
export const getRefundNotifications = async (): Promise<ReadonlyArray<RefundNotification>> => {
  const response = await api.get<RefundNotificationsResponse>('/user/refund-notifications');
  return response.data.notifications;
};

/**
 * Acknowledge a refund notification (mark as seen)
 */
export const acknowledgeRefundNotification = async (paymentId: string): Promise<void> => {
  await api.post(`/user/refund-notifications/${paymentId}/acknowledge`);
};
